import { render } from "./SalonDashboard.vue?vue&type=template&id=7edb732c&scoped=true"
import script from "./SalonDashboard.vue?vue&type=script&lang=js"
export * from "./SalonDashboard.vue?vue&type=script&lang=js"

import "./SalonDashboard.vue?vue&type=style&index=0&id=7edb732c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edb732c"]])

export default __exports__